import { render, staticRenderFns } from "./AccordionWrapper.vue?vue&type=template&id=7fdf655e&scoped=true"
import script from "./AccordionWrapper.vue?vue&type=script&lang=js"
export * from "./AccordionWrapper.vue?vue&type=script&lang=js"
import style0 from "./AccordionWrapper.vue?vue&type=style&index=0&id=7fdf655e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf655e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionWrapper.vue
// module id = 165
// module chunks = 0